import React from 'react';
import { Link } from 'react-router-dom';

import {
  Layout,
  Row,
  Col,
  List,
} from 'antd';

import Logo from 'components/Logo/Logo';
import styles from './Footer.module.scss';

const data = [
  [
    {
      title: 'Les essentiels',
      list: [
        {
          link: 'http://www.onf.fr/onf/@@index.html',
          label: 'Connaître l\'ONF',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/gestion_durable/@@index.html',
          label: 'Gérer les forêts',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/communes_forestieres/@@index.html',
          label: 'Aux côtés des communes',
          type: 'url',
        },
      ],
    },
    {
      title: 'Le groupe ONF',
      list: [
        {
          link: 'http://www.onf-energie-bois.com/',
          label: 'Réseau Energie bois',
          type: 'url',
        },
        {
          link: 'http://www.onf-energie-bois.com/',
          label: 'ONF international',
          type: 'url',
        },
      ],
    },
  ],
  [
    {
      title: 'Pour les pros',
      list: [
        {
          link: 'http://www.onf.fr/filiere_bois/@@index.html',
          label: 'Filière bois',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/produits_prestations/@@index.html',
          label: 'Produits et prestations de service',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/presse_medias/@@index.html',
          label: 'Presse et médias',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/fournisseurs/@@index.html',
          label: 'Fournisseurs',
          type: 'url',
        },
      ],
    },
    {
      title: 'Crédits',
      list: [
        {
          link: '/pages/mentions-legales',
          label: 'Mentions légales',
          type: 'route',
        },
        {
          link: '/pages/credits',
          label: 'Crédits',
          type: 'route',
        },
      ],
    },
  ],
  [
    {
      title: 'Loisirs nature',
      list: [
        {
          link: 'http://www.onf.fr/enforet/@@index.html',
          label: 'En forêt de ...',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/activites_nature/@@index.html',
          label: 'Loisirs en forêt',
          type: 'url',
        },
        {
          link: 'http://gitesetrandonnees.onf.fr/',
          label: 'Gîtes et randonnées',
          type: 'url',
        },
        {
          link: 'http://www.arboretumdesbarres.fr/',
          label: 'Arboretum des Barres',
          type: 'url',
        },
        {
          link: 'http://www.espacerambouillet.fr/',
          label: 'Espace Rambouillet',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/odysseeverte/@@index.html',
          label: 'Odyssée Verte®',
          type: 'url',
        },
        {
          link: 'http://www.chasse.onf.fr/',
          label: 'Chasse',
          type: 'url',
        },
      ],
    },
  ],
  [
    {
      title: 'Les thématiques',
      list: [
        {
          link: 'http://www.onf.fr/foret-exception/@@index.html',
          label: 'Forêt d\'Exception®',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/renecofor/@@index.html',
          label: 'Renecofor',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/pnaa/@@index.html',
          label: 'Plans nationaux d\'action',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/projets_europeens/@@index.html',
          label: 'Projets européens',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/forets-grande-guerre/@@index.html',
          label: 'Forêts et Grande Guerre',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/dunes-forets-aquitaine/@@index.html',
          label: 'Dunes et forêts du littoral atlantique',
          type: 'url',
        },
      ],
    },
    {
      title: 'Ressources',
      list: [
        {
          link: 'http://www.onf.fr/lire_voir_ecouter/sommaire/en_images/@@index.html',
          label: 'En images',
          type: 'url',
        },
        {
          link: 'http://www.onf.fr/lire_voir_ecouter/@@index.html',
          label: 'Lire, voir, écouter',
          type: 'url',
        },
      ],
    },
  ],
];

const Footer = () => (
  <Layout.Footer className={styles.footer}>

    <footer className="wrapper">
      <Row gutter={16}>
        {data.map(col => (
          <Col
            key={col[0].title}
            xs={24}
            sm={24}
            md={12}
            lg={5}
          >
            <List
              className={styles.footerList}
              itemLayout="vertical"
              dataSource={col}
              grid={{ gutter: 16 }}
              renderItem={item => (
                <List.Item>
                  <List.Item.Meta
                    className={styles.footerListItem}
                    title={item.title}
                    description={(
                      <ul>
                        {item.list.map(elem => (
                          <li key={elem.label}>
                            {elem.type === 'route' && <Link to={elem.link}>{elem.label}</Link>}
                            {elem.type === 'url' && <a href={elem.link}>{elem.label}</a>}
                          </li>
                        ))}
                      </ul>
                    )}
                  />
                </List.Item>
              )}
            />
          </Col>
        ))}
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={4}
        >
          <Link className={styles.logo} to="/"><Logo className={styles.logo__symbol} /><span className={styles.logo__hidden}>Office National des forêts</span></Link>
        </Col>
      </Row>
    </footer>

  </Layout.Footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Layout/Footer/Footer.js